let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1br2a")).then(() => parcelRequire('lQFmB'));